import styled from 'styled-components';

export const CaseReportEventEvidenceContainer = styled.div`
  display: flex;
  flex-grow: 10;
  flex-direction: column;
`;

export const CaseReportEventEvidenceListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 11px;
  margin-right: auto;
  gap: 4px;
`;
